import React, { useState } from 'react';
import classNames from 'classnames';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import { Button } from '@shared/UI';
import { usePageSelect } from './usePageSelect';
import { SetPage } from '../../interfaces';
import { generateId } from '@shared/utils';
import './PageSelect.scss';

interface PageSelectProps {
    page: number;
    setPage: SetPage;
    pageCount: number;
}

export const PageSelect: React.FC<PageSelectProps> = (props) => {
    const { page, setPage, pageCount } = props;

    const { buttonsData, prevShown, nextShown, toStartShown, toEndShown, prev, next, toStart, toEnd, buttonClick } =
        usePageSelect({
            page,
            setPage,
            pageCount,
        });

    const [toEndButtonUd] = useState<string>(generateId());

    if (pageCount < 2) return <></>;

    return (
        <div className='feature-paginator-page-select'>
            {page > 2 && (
                <Button
                    onClick={toStart}
                    className='feature-paginator-page-select__button secondary run'
                    disabled={!toStartShown}
                >
                    <AiOutlineDoubleLeft />
                </Button>
            )}
            <Button
                onClick={prev}
                className='feature-paginator-page-select__button secondary'
                disabled={!prevShown}
            >
                <AiOutlineLeft />
            </Button>
            {buttonsData.map((buttonData) => {
                return (
                    <Button
                        id={`page-${buttonData}`}
                        key={buttonData}
                        className={classNames('feature-paginator-page-select__button number', {
                            active: buttonData === page,
                        })}
                        onClick={buttonClick}
                    >
                        {buttonData}
                    </Button>
                );
            })}
            <Button
                onClick={next}
                className='feature-paginator-page-select__button secondary'
                disabled={!nextShown}
            >
                <AiOutlineRight />
            </Button>
            {page < pageCount - 2 && (
                <Button
                    id={toEndButtonUd}
                    onClick={toEnd}
                    className='feature-paginator-page-select__button secondary run'
                    disabled={!toEndShown}
                >
                    <AiOutlineDoubleRight />
                </Button>
            )}
        </div>
    );
};
